import React from "react";
import invest from "../../assets/invest.jpg";
import expert from "../../assets/expert.jpg";
import ethics from "../../assets/ethics.jpg";

const WhyChooseus = () => {
  return (
    <div className="bg-[#F3F4F6] py-16 sm:py-20 flex justify-center items-center">
      <div className="mx-auto max-w-4xl px-4 md:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0F172A] mb-12">
          Why Choose US
        </h2>

        <div className="flex flex-wrap justify-center gap-8 lg:gap-20">
          <div className="md:w-[320px] flex flex-col items-center text-center">
            <div className="relative w-[200px] h-[200px] lg:w-[250px] lg:h-[250px] overflow-hidden rounded-full">
              <img
                src={expert}
                alt="Data-Driven Research"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
            <div className="mt-4">
              <h2 className="text-base md:text-lg lg:text-xl font-semibold">Data-Driven Research</h2>
              <p className="mt-3 text-sm md:text-base lg:text-lg">
                Our research reports are backed by extensive research.
              </p>
            </div>
          </div>

          <div className="md:w-[320px] flex flex-col items-center text-center">
            <div className="relative w-[200px] h-[200px] lg:w-[250px] lg:h-[250px]  overflow-hidden rounded-full">
              <img
                src={invest}
                alt="Tailored Investment Solutions"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
            <div className="mt-4">
              <h2 className="text-base md:text-lg lg:text-xl font-semibold">
                Tailored Investment Solutions
              </h2>
              <p className="mt-3 text-sm md:text-base lg:text-lg">
                We offer personalized services that cater to both new and
                experienced investors.
              </p>
            </div>
          </div>

          <div className="md:w-[320px] flex flex-col items-center text-center">
            <div className="relative w-[200px] h-[200px] lg:w-[250px] lg:h-[250px]  overflow-hidden rounded-full">
              <img
                src={ethics}
                alt="Ethical and Transparent Practices"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
            <div className="mt-4">
              <h2 className="text-base md:text-lg lg:text-xl font-semibold">
                Ethical and Transparent Practices
              </h2>
              <p className="mt-3 text-sm md:text-base lg:text-lg">
                We adhere to the highest standards of ethics and transparency.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseus;
